import { http } from '@/network/http'
import {
    addGA,
    errorGA,
    initGA,
    inlineStyle,
    deleteCookie
} from '@/utils'
import api from '@/api'
import { Toast } from 'vant'

interface Params {
    profile: object
    apkLink: string
    feedbackQuestions: Array<object>
    imageUpload: boolean
}

let stateStorage
if (sessionStorage.getItem('store')) {
    stateStorage = JSON.parse(sessionStorage.getItem('store') || '')
} else {
    stateStorage = {}
}
const state = {
    css: stateStorage.css || '',
    config: stateStorage.config || null,
    // isLogin: true,
    // isRegister: true,
    isLogin: stateStorage.isLogin || false, // login status
    isRegister: stateStorage.isRegister || false, // register status
    profile: stateStorage.profile || null,
    userEmail: stateStorage.userEmail || '',
    lang: stateStorage.lang || null,
    region: stateStorage.region || 'en',
    activationCode: stateStorage.activationCode || '',
    feedbackHistory: stateStorage.feedbackHistory || null,
    nationCode: stateStorage.nationCode || '',
    playtestStartTime: stateStorage.playtestStartTime || 0,
    downloadOpen: stateStorage.downloadOpen || false,
    feedbackOpen: stateStorage.feedbackOpen || false,
    registerOpen: stateStorage.registerOpen || false,
    apkLink: stateStorage.apkLink || '',
    questions: stateStorage.questions || null,
    imageUpload: stateStorage.imageUpload || false,
    gameLogin: stateStorage.gameLogin || true, // adv game login
    loginFrom: stateStorage.loginFrom || 'external',
    transify: stateStorage.transify || {
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_LOGIN_FAILED: 'Login failed'
    },
    has_activation_code: 1, // 1为设置告警，已经用完，其他情况为0
    indexInit: false
}

const judgeTime = (start: any, end: any) => {
    const now = Date.parse(new Date().toString()) / 1000
    if (now < end && now >= start) {
        return true
    } else {
        return false
    }
}
const handleError = (error: any, delay?: number, hideClose?: boolean) => {
    errorGA(error)

    let err: string | undefined
    const transify = ''

    if (transify) {
        if (typeof error === 'string') {
            err = transify[error]
        } else if (error.message) {
            err = transify[error.message]
        }
    }
}

const mutations = {
    setValue(state: any, data: any) {
        state[data.key] = data.value
    }
}

const actions = {
    getConfig({ commit }: any, lang: string) {
        commit('setValue', {
            key: 'lang',
            value: lang
        })
        http
            .get(`${api.config}?lang=${lang}`)
            .then((res: any) => {
                const resData = res.data
                commit('setValue', {
                    key: 'region',
                    value: resData.region
                })
                commit('setValue', {
                    key: 'transify',
                    value: resData.transify
                })
                // 是否存在注册激活码
                commit('setValue', {
                    key: 'has_activation_code',
                    value: resData.has_activation_code
                })
                commit('setValue', {
                    key: 'downloadOpen',
                    value: judgeTime(resData.playtest_time[0], resData.playtest_time[1])
                })
                commit('setValue', {
                    key: 'feedbackOpen',
                    value: judgeTime(resData.playtest_time[0], resData.playtest_time[1])
                })
                commit('setValue', {
                    key: 'playtestStartTime',
                    value: resData.playtest_time[0]
                })
                commit('setValue', {
                    key: 'registerOpen',
                    value: judgeTime(resData.register_time[0], resData.register_time[1])
                })
                switch (resData.region) {
                    case 'pt':
                        commit('setValue', {
                            key: 'nationCode',
                            value: '55'
                        })
                        break
                    case 'id':
                        commit('setValue', {
                            key: 'nationCode',
                            value: '62'
                        })
                        break
                }
                commit('setValue', {
                    key: 'indexInit',
                    value: true
                })
                inlineStyle(resData.css) // 加载CSS
                initGA(resData.region, 0)
                addGA('get config', 'success')
            })
            .catch((e: any) => {
                handleError(e)
                errorGA(e)
            })
    },
    setProfile({ commit }: any, obj: Params) {
        const { profile, apkLink } = obj
        commit('setValue', {
            key: 'profile',
            value: profile
        })
        commit('setValue', {
            key: 'apkLink',
            value: apkLink
        })
        commit('setValue', {
            key: 'questions',
            value: obj.feedbackQuestions
        })
        commit('setValue', {
            key: 'imageUpload',
            value: obj.imageUpload
        })
    },
    setHistory({ commit }: any, history: object[]) {
        commit('setValue', {
            key: 'feedbackHistory',
            value: history
        })
    },
    setLoginFrom({ commit }: any, from: string) {
        commit('setValue', {
            key: 'loginFrom',
            value: from
        })
    },
    setUserInfo({ commit }: any, data: any) {
        commit('setValue', {
            key: 'isRegister',
            value: data.registered
        })
        commit('setValue', {
            key: 'isLogin',
            value: true
        })
        commit('setValue', {
            key: 'userEmail',
            value: data.email
        })
        if (data.registered) {
            commit('setValue', {
                key: 'questions',
                value: data.feedback_questions
            })
            commit('setValue', {
                key: 'profile',
                value: {
                    name: data.name,
                    email: data.email,
                    tel: data.tel,
                    lang: state.region
                }
            })
            commit('setValue', {
                key: 'apkLink',
                value: data.apk_url
            })
            commit('setValue', {
                key: 'activationCode',
                value: data.activation_code
            })
            commit('setValue', {
                key: 'imageUpload',
                value: data.feedback_image_upload
            })
        }
    },
    // 登陆
    login({ commit }: any, type: string) {
        // type === 1 登录线上服、type === 2登录测试服
        const callbackUrl: string = 'https://ff-advance.ff.garena.com/'
        // 后面要换回来
        if (type === 'fb') {
            window.location.href = `https://auth.garena.com/oauth/login?client_id=100067&redirect_uri=${callbackUrl}&response_type=token&all_platforms=1&platform=3`
        }
        if (type == 'google') {
            window.location.href = `https://auth.garena.com/oauth/login?client_id=100067&redirect_uri=${callbackUrl}&response_type=token&all_platforms=1&platform=8`
        }
        addGA('user try to login', 'true')
    },
    // 登出
    logout({ commit }: any) {
        commit('setValue', {
            key: 'isLogin',
            value: false
        })
        commit('setValue', {
            key: 'userEmail',
            value: ''
        })
        deleteCookie('liveAccessToken')
    },
    // handlerError
    handleError({ commit }: any, msg: string = '') {
        Toast['fail'](state.transify[msg] || state.transify['TOAST_NETWORK_BUSY'])
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
